import React, { useState, useEffect, useContext } from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import { NavigationContext } from '@react-navigation/native';
import { isIOS, isPresent } from '../../utils/BooleanUtility';
import TabAppCues from '../shared/TabAppCues';
import FastImageView from '../FastImageView';
import { jsonParser } from '../../utils/JsonUtility';
import RemoteConfig from '../../utils/RemoteConfig';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';

const RoutinesTabIcon = ({ image, style, hideAppCue }) => {
  const [isAppCueShown, setIsAppCueShown] = useState(false);
  const navigation = useContext(NavigationContext);
  const activeRoutineSlugs = useSelector((state) => state.UserAccountInfo?.activeRoutineSlugs);

  const { showIcon = false, image: iconImage = '' } =
    jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.tab_icon)) || {};

  const isIconShown = showIcon || isPresent(activeRoutineSlugs);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      if (!isAppCueShown) {
        setIsAppCueShown(true);
      }
    });
    return unsubscribe; // Clean up listener on unmount
  }, [navigation, isAppCueShown]);

  return (
    <View testID='routine-tab-icon' accessibilityLabel='routine-tab-icon'>
      <Image source={image} style={style} />
      {isIconShown && (
        <View style={styles.liveIndicatorStyle}>
          <FastImageView source={iconImage} style={styles.liveIndicatorStyle} />
        </View>
      )}
      {!hideAppCue && !isAppCueShown && <TabAppCues />}
    </View>
  );
};

const styles = StyleSheet.create({
  liveIndicatorStyle: {
    position: 'absolute',
    width: 25,
    height: 25,
    alignSelf: 'flex-end',
    bottom: 5,
    left: 8,
  },
});

export default RoutinesTabIcon;
